import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing.km2};
    justify-content: end;

    fuel-button::part(button) {
      min-width: 53px;
    }
  `}
`;
